/**
 * Briefing „Arbeitsfreude“ AF18: Eine eigene Änderung ist vom Server bestätigt – Ansichten können den gespeicherten
 * Wert kurz hervorheben (Tabelle). Nur eigene Änderungen, nie Live-Ereignisse anderer (keine Bewegung durch fremde
 * Updates, AF13).
 */
export const SAVED_EVENT = 'werft:saved';
export interface SavedDetail {
  taskId: string;
  /** DTO-Felder, z. B. `dueDate`, `assigneeIds` */
  fields: string[];
}
export function notifySaved(taskId: string, fields: string[]) {
  window.dispatchEvent(new CustomEvent<SavedDetail>(SAVED_EVENT, { detail: { taskId, fields } }));
}
